<template>
    <div class="registration">
        <h2 class="registration-header">Registrace 2021 spuštěna</h2>
        <ul class="mb-0">
            <li>Registrace na jubilejní 15. ročník Triatlonu sportovních osobností spuštěna</li>
            <li>Závod proběhne v sobotu <strong>28.8.2021</strong> na Biřičce v Hradci Králové</li>
            <li>Startovné zůstává <strong>250,- Kč</strong>. Registrace je otevřena pouze <strong>do neděle 6.6.2021 23:59</strong>. Poté bude pro velký zájem startovní listina uzavřena.</li>
            <li>Pro registraci na závod zašlete startovné na účet <strong style="white-space: nowrap">27-318920237/0100</strong>. Do <strong>zprávy pro příjemce</strong> uveďte <strong>své jméno</strong></li>
            <li>Veškeré dotazy zasílejte letos <strong>Jirkovi Balickému</strong> na adresu <strong><a href="mailto:jbalicky@seznam.cz">jbalicky@seznam.cz</a></strong></li>
            <li><strong>Sponzorské dary jsou vítány!</strong></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Registration"
    };
</script>

<style scoped lang="scss">
    @import "~@/assets/scss/_variables.scss";
    .registration {
        margin-top: 1rem;
        border-left: thick solid $primary;
        padding: 1rem;
        background-color: lighten($primary, 40);
        .registration-header {
            color: $primary
        }
    }
</style>